module.exports = __webpack_public_path__ + "static/media/getonapple.33029689.png";